import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

export type ConsentProposals = {
    viewId: string;
    id: string;
    status: string;
};

export type SignApplicationResponse = {
    signLink: string;
};

export const getSigningLinkService = async (
    apiProxyPath: string,
    apiKey: string,
    arn: string | undefined,
    consentProposals: ConsentProposals[],
    isDesktop: boolean,
    authenticationData?: AuthenticationData,
): Promise<SignApplicationResponse> => {
    return apiClient<SignApplicationResponse>(
        `${apiProxyPath}/application/${arn}/signing_link?isDesktop=${isDesktop}`,
        {
            method: 'POST',
            body: { consentProposals },
            apiKey,
            authenticationData,
            sentryTag: 'get_signing_link',
            sentryExtra: { arn, isDesktop },
        },
    );
};
